import { DateTime } from 'luxon';
import { HTMLProps, useContext } from 'react';
import { Rate, useGetFundRates } from '../../../../api/funds-robot/getFundRates';
import { ComparisonScreenFundSelectionContext } from '../ComparisonScreen';
import { BNLRatesMonth } from './BNLRatesMonth';
import { monthNames } from './NavDailyRates';

export const BNLRates: React.FC<{ selectedYear: number } & HTMLProps<HTMLDivElement>> = ({
    className,
    selectedYear,
}) => {
    const { selectedFund } = useContext(ComparisonScreenFundSelectionContext);
    const fundRateData = useGetFundRates(
        !!selectedFund ? selectedFund.id : undefined,
        DateTime.now(),
        DateTime.now().minus({ year: 10 }),
    );

    let formattedBNLData: { monthName: string; data: number[][] }[] = [];
    if (!!fundRateData.data) {
        formattedBNLData = createBNLData(
            fundRateData.data.rates.filter((rate) => DateTime.fromISO(rate.date).year === selectedYear),
            selectedYear,
        );
    } else {
        formattedBNLData = createBNLData([], selectedYear);
    }
    return (
        <div className={`flex flex-wrap justify-center ${className} `}>
            {formattedBNLData.map((month, index) => {
                return <BNLRatesMonth monthName={month.monthName} ratesData={month.data} key={index} />;
            })}
        </div>
    );
};

const createBNLData = (rates: Rate[], selectedYear: number) => {
    const formattedData = monthNames.map((month) => {
        let temporaryMonthData = rates.filter((rate) => DateTime.fromISO(rate.date).month === month.number);
        //let startDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: 1 });
        let daysInCurrentMonth = DateTime.fromObject({ year: selectedYear, month: month.number }).daysInMonth;
        let endDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: daysInCurrentMonth });
        let monthValues: number[][] = [];
        let dateRate: Rate[];
        for (
            let startDate = DateTime.fromObject({ year: selectedYear, month: month.number, day: 1 });
            startDate <= endDate;
            startDate = startDate.plus({ day: 1 })
        ) {
            dateRate = temporaryMonthData.filter((rate) => DateTime.fromISO(rate.date).day === startDate.day);
            if (dateRate.length > 0) {
                monthValues = monthValues.concat([[dateRate[0].bidPrice, dateRate[0].nav, dateRate[0].askPrice]]);
            } else {
                monthValues = monthValues.concat([[-1, -1, -1]]);
            }
        }
        return { monthName: month.name, data: monthValues };
    });
    return formattedData;
};
